import { isNil } from 'lodash-es'

import { TSearchRoom } from '@/entities/map'
import { formatCurrency } from '@/shared/lib'

export type Props = Partial<Pick<TSearchRoom, 'usingFee' | 'mgmtFee'>>

export const PriceDetail = ({ usingFee, mgmtFee }: Props) => {
  if (isNil(usingFee) || isNil(mgmtFee)) return null

  return (
    <div className="typo-label1 flex gap-2 font-normal text-gray-500 not-last:mb-2">
      <p className="space-x-1">
        <span>임대료</span>
        <span className="text-gray-900">{formatCurrency(usingFee)}원</span>
      </p>
      <p className="space-x-1">
        <span>관리비</span>
        <span className="text-gray-900">{formatCurrency(mgmtFee)}원</span>
      </p>
    </div>
  )
}
